@if (authStep$ | async; as authStep) { @if (authStep.isAuthorized) { @if (userProfile$ | async) {
<div class="app-layout app-layout-authorized" [dir]="direction">
  <app-header [authorized]="true" [authenticated]="authStep.isAuthenticated"></app-header>
  @if (accounts$ | async) {
  <app-main></app-main>
  }
  <app-footer></app-footer>
</div>
} } @else {
<div class="app-layout app-layout-unauthorized" [dir]="direction">
  @if (isHeaderFooterVisible) {
  <app-header [authenticated]="authStep.isAuthenticated"></app-header>
  }
  <app-main></app-main>
  @if (isHeaderFooterVisible) {
  <app-aside></app-aside>
  }
</div>
} }
